import styled from "styled-components";
import fonts from "styles/fonts";

export const StyledErrorMessage = styled.p`
  font-size: ${fonts.small};
  font-weight: 600;
  margin-left: 1em;
`;
